export default class StrongPassword {
  constructor() {
    'ngInject';

    this.require = 'ngModel';
    this.restrict = 'A';
  }

  link($scope, element, attrs, ctrl) {
    ctrl.$validators.strongPassword = (modelValue) => {
      // check if contains uppercase
      if (!/[A-Z]/.test(modelValue)) {
        return false;
      }

      // check if contains lowercase
      if (!/[a-z]/.test(modelValue)) {
        return false;
      }

      // check if contains number
      if (!/[0-9]/.test(modelValue)) {
        return false;
      }

      if (modelValue.length < 8) {
        return false;
      }

      return true;
    };
  }

  static directiveFactory() {
    'ngInject';

    return new StrongPassword();
  }
}



// WEBPACK FOOTER //
// ./common/directives/validation/strong-password.js